<script setup lang="ts">
import { Block, Button, ButtonGroup, Confirm, LayoutGap, Prompt, Toaster } from '@dabble/quillui';

const version = __APP_VERSION__;
</script>

<template>
  <div class="page-layout">
    <LayoutGap direction="column" padding="small" align="center" class="page-layout__container">
      <LayoutGap
        direction="row"
        padding="small"
        verticalAlign="center"
        align="space-between"
        class="page-layout__header"
      >
        <div class="page-layout__logo">
          <img src="/images/dabble-icon.svg" alt="Dabble" />
        </div>
        <div>
          <ButtonGroup variant="ghostbar">
            <Button :to="{ name: 'home' }" iconLeft="home" variant="primary" finish="ghost"> Home </Button>
            <Button :to="{ name: 'connections' }" iconLeft="web" variant="primary" finish="ghost"> Connections </Button>
            <Button :to="{ name: 'data' }" iconLeft="folder" variant="primary" finish="ghost"> Data </Button>
            <Button :to="{ name: 'offerings' }" iconLeft="billing" variant="primary" finish="ghost"> Offerings </Button>
            <Button :to="{ name: 'features' }" iconLeft="flag" variant="primary" finish="ghost"> Features </Button>
            <Button :to="{ name: 'home' }" iconLeft="user" variant="primary" finish="ghost"> Users </Button>
          </ButtonGroup>
        </div>
        <div class="page-layout__corner">&nbsp;</div>
      </LayoutGap>
      <main class="page-layout__main">
        <Block padding="small" elevation="small" borderRadius="small" class="page-layout__content">
          <slot />
        </Block>
      </main>
      <footer class="page-layout__footer">
        <span class="page-layout__version">Dabble Admin v{{ version }}</span>
      </footer>
    </LayoutGap>
  </div>
  <Toaster />
  <Confirm />
  <Prompt />
</template>

<style lang="scss" scoped>
.page-layout {
  $self: &;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  color: theme('color-text-primary');
  background: theme('color-bg-primary');

  /* Component styles goes here… */
  &__container {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  &__logo {
    width: 3rem;
    height: 3rem;
    img {
      width: 100%;
    }
  }
  &__corner {
    width: 3rem;
    height: 3rem;
  }
  &__header {
    flex: 0 0 auto;
    width: 100%;
    max-width: 1400px;
    padding: 0 space('medium');

    @media (max-width: 768px) {
      padding: 0 space('small');
    }
  }
  &__main {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1400px;
    flex: 1 1 auto;
    margin-bottom: space('medium');
    padding: 0 space('medium');

    @media (max-width: 768px) {
      padding: 0 space('small');
    }
  }
  &__content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }
  &__content > :global(.block__content) {
    flex: 1 1 auto;
  }
  &__footer {
    flex: 0 0 auto;
    width: 100%;
    max-width: 1400px;
    padding: 0 space('medium') space('small');
    text-align: center;

    @media (max-width: 768px) {
      padding: 0 space('small') space('small');
    }
  }
  &__version {
    font-size: fontSize('xsmall');
    color: theme('color-text-secondary');
  }
}
</style>
